<button *ngIf='!loginDisplay' mat-raised-button data-cy='sign-in-button' i18n (click)='loginRedirect()'>
  Sign in with L'OREAL AD
</button>
